//Import redux types
import {
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_ERROR,
  GET_UNREAD_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_ERROR,
  RESET_ALL_NOTIFICATIONS,
  APPEND_NOTIFICATIONS,
  SET_HAS_MORE_NOTIFICATIONS,
  GET_NOTIFICATION_BY_ID,
  GET_NOTIFICATION_BY_ID_ERROR,
} from "../actions/types";

//Initial state object
const initialState = {
  unread: 0,
  notifications: [], // Now always an array
  loading: true,
  error: false,
  hasMore: true,
  total: 0,
  failures: [], // For debugging/analytics
  notificationDetail: null,
};

export default function (state = initialState, action) {
  //Destructure action
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload.notifications,
        loading: false,
        error: false,
      };
    case APPEND_NOTIFICATIONS:
      return {
        ...state,
        notifications: [...state.notifications, ...payload.notifications],
        hasMore: payload.hasMore,
        total: payload.total,
        unread: payload.unread,
        failures: payload.failures || [],
        loading: false,
        error: false,
      };
    case SET_HAS_MORE_NOTIFICATIONS:
      return {
        ...state,
        hasMore: payload,
      };
    case GET_NOTIFICATION_BY_ID:
      return {
        ...state,
        notificationDetail: payload,
        loading: false,
        error: false,
      };
    case GET_NOTIFICATION_BY_ID_ERROR:
      return {
        ...state,
        notificationDetail: null,
        error: true,
      };
    case GET_ALL_NOTIFICATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        notifications: [],
      };
    case GET_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unread: payload.unread,
      };
    case GET_UNREAD_NOTIFICATIONS_ERROR:
      return {
        ...state,
      };
    case RESET_ALL_NOTIFICATIONS:
      return {
        ...state,
        unread: 0,
        notifications: [],
        error: false,
        loading: true,
        hasMore: true,
        total: 0,
        failures: [],
        notificationDetail: null,
      };

    default:
      return state;
  }
}
